import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { FaFacebookSquare, FaLinkedin } from "react-icons/fa";
import "./App.css";
import { ReactComponent as TopArrow } from "./assests/images/top-arrow.svg";

import { MotoComponent } from "./components/About";
import { ContactsComponent } from "./components/Contacts";
import { Hero } from "./components/hero/hero";
import { Menu } from "./components/menu/menu";
import { ServicesComponent } from "./components/Services";
import { TechnologiesComponent } from "./components/Techologies";

function App() {
 const [showScrollTop, setShowScrollTop] = useState(false);

 useEffect(() => {
  document.title = "Soft Forging";
  const onScroll = () => setShowScrollTop(window.scrollY > window.innerHeight * 0.8);
  window.addEventListener("scroll", onScroll);
  return () => window.removeEventListener("scroll", onScroll);
 }, []);

 return (
  <main className="App">
   <Helmet>
    <title>Soft Forging</title>
    <link rel="canonical" href="https://www.softforging.com/" />
    <meta name="description" content="Software development company - Web/Mobile/AI/ML development." />
    <meta name="title" content="Soft Forging - Crafting Modern Web Solutions" />
    <meta name="keywords" content="Programing, Development, App Develpment, Software, AI, ML, Python, Web Apps" />
    <meta name="author" property="og:author" content="Soft Forging development company" />
    <meta property="og:title" content="Soft Forging - Crafting Modern Web Solutions" />
    <meta property="og:description" content="We specialize in crafting modern, scalable, and secure web solutions tailored to your unique needs." />
    <meta property="og:image" content="https://www.softforging.com/logo-1200-630.jpg" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:url" content="https://softforging.com" />
    <meta property="og:type" content="website" />
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css" />
   </Helmet>

   <Menu />

   {showScrollTop && (
    <div className="home-scroll-top-btn" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
     <TopArrow />
    </div>
   )}

   <Hero />

   <div className="home-body">
    <div className="home-content">
     <MotoComponent />
     <ServicesComponent />
     <TechnologiesComponent />
     <ContactsComponent />
    </div>
   </div>

   <footer className="app-footer">
    <div className="footer-brand">
     <span className="footer-brand-name">
      Soft<span className="gradient-text">Forging</span>
     </span>
     <span className="footer-copy">© SoftForging LTD {new Date().getFullYear()}. All rights reserved.</span>
    </div>
    <div className="social">
     <a href="https://www.linkedin.com/company/soft-forging/" aria-label="LinkedIn" target="_blank" rel="noreferrer">
      <FaLinkedin />
     </a>
     <a href="https://www.facebook.com/profile.php?id=61573030192171" aria-label="Facebook" target="_blank" rel="noreferrer">
      <FaFacebookSquare />
     </a>
    </div>
    <div className="email">
     <span>{"// email"}</span>
     <a href="mailto:office@softforging.com">office@softforging.com</a>
    </div>
   </footer>
  </main>
 );
}

export default App;
